import React, { useEffect, useState, useRef } from "react";
import Modal from "../Modal";
import { ReactComponent as BlackScale } from "assets/icons/BlackScale.svg";
import { ReactComponent as BlackRing } from "assets/icons/BlackRing.svg";
import { ReactComponent as HourGlass } from "assets/icons/HourGlass.svg";
import { ReactComponent as Cross } from "assets/icons/update_img_icons/cross.svg";

const EditLimitsModal = ({
  createLimit,
  sendLimit,
  hourLimit,
  setCreateLimit,
  setSendLimit,
  setHourLimit,
  onSave,
  open,
  handleClose,
  isRole,
}) => {
  // store initial values once when modal opens
  const initialValues = useRef({
    create: createLimit,
    send: sendLimit,
    hour: hourLimit,
  });

  const [isChanged, setIsChanged] = useState(false);

  // detect changes
  useEffect(() => {
    const changed =
      createLimit !== initialValues.current.create ||
      sendLimit !== initialValues.current.send ||
      hourLimit !== initialValues.current.hour;

    setIsChanged(changed);
  }, [createLimit, sendLimit, hourLimit]);

  useEffect(() => {
    if (open) {
      initialValues.current = {
        create: createLimit,
        send: sendLimit,
        hour: hourLimit,
      };
      setIsChanged(false);
    }
  }, [open]);
  

  // clear all → restore initial values
  const handleClearAll = () => {
    setCreateLimit(initialValues.current.create);
    setSendLimit(initialValues.current.send);
    setHourLimit(initialValues.current.hour);
  };

  const styles = {
    titleRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    closeIcon: { cursor: "pointer", width: 15, height: 15 },
    clearAll: {
      fontSize: 16,
      color: "#444444",
      cursor: "pointer",
      fontWeight: 500,
      fontFamily: "Poppins",
    },
    title: { fontFamily: "Poppins", fontSize: 24, fontWeight: 500 },
    divider: { width: "100%", height: 1, background: "#8B8B8B", margin: "0 0 15px" },
    row: {
      display: "grid",
      gridTemplateColumns: "30px 1fr 80px",
      alignItems: "center",
      marginBottom: 18,
    },
    label: { fontFamily: "Karla", fontSize: 20, fontWeight: 500 },
    input: {
      width: 70,
      padding: "6px 10px",
      borderRadius: 6,
      border: "1px solid #BFBFBF",
      textAlign: "center",
      fontSize: 16,
      outline: "none",
    },
    saveBtn: {
      width: "183px",
      padding: "12px 0",
      background: isChanged ? "#50C878" : "#444444",
      color: "#000",
      border: "none",
      borderRadius: 8,
      fontSize: 18,
      fontWeight: 500,
      cursor: isChanged ? "pointer" : "not-allowed",
      marginTop: 10,
      fontFamily: "Poppins",
    },
  };

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "385px" }}>
      {/* Header */}
      <div style={styles.titleRow}>
        <h2 style={styles.title}>Edit Limits</h2>

        {/* SHOW CLOSE ICON ONLY WHEN NO CHANGES */}
        {!isChanged ? (
          <Cross style={styles.closeIcon} onClick={handleClose} />
        ) : (
          <span style={styles.clearAll} onClick={handleClearAll}>
            Clear All
          </span>
        )}
      </div>

      <div style={styles.divider} />

      {/* Create Limit */}
      {isRole && 
        <div style={styles.row}>
          <span><BlackRing /></span>
          <label style={styles.label}>{"Create Catalog Limit"}</label>
          <input
            type="text"
            style={styles.input}
            value={createLimit}
            onChange={(e) => {
              const val = e.target.value;
              if (/^[0-9]*$/.test(val)) setCreateLimit(val);
            }}
          />
        </div>
      }

      {/* Send Limit */}
      <div style={styles.row}>
        <span><BlackScale /></span>
        <label style={styles.label}>Send Catalog Limit</label>
        <input
          type="text"
          style={styles.input}
          value={sendLimit}
          onChange={(e) => {
            const val = e.target.value;
            if (/^[0-9]*$/.test(val)) setSendLimit(val);
          }}
        />
      </div>

      {/* Hour Limit */}
      {isRole && 
        <div style={styles.row}>
          <span><HourGlass /></span>
          <label style={styles.label}>Hour Limit</label>
          <input
            type="text"
            style={styles.input}
            value={hourLimit}
            // onChange={(e) => {
            //   const val = e.target.value;
            //   if (/^[0-9]*$/.test(val)) setHourLimit(val);
            // }}
            onChange={(e) => {
              const val = e.target.value;
      
              // allow empty (for backspace)
              if (val === "") {
                setHourLimit("");
                return;
              }
      
              // only numbers 1–72
              const num = Number(val);
              if (/^[0-9]+$/.test(val) && num >= 1 && num <= 72) {
                setHourLimit(val);
              }
            }}
          />
        </div>
      }

      {/* Save Button */}

      <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%"}}>
      <button
        style={styles.saveBtn}
        disabled={!isChanged}
        onClick={() => isChanged && onSave()}
      >
        Save
      </button>
      </div>
    </Modal>
  );
};

export default EditLimitsModal;
